import { createFileRoute } from '@tanstack/react-router'
import { PreferencesContent } from '../../../features/preferences/Preferences.tsx'

export const Route = createFileRoute('/_app/m/_mobile/preferences')({
	component: RouteComponent,
})

function RouteComponent() {
	return <PreferencesContent />
}
